import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=57affc4e&scoped=true&"
import script from "./Form.vue?vue&type=script&lang=ts&"
export * from "./Form.vue?vue&type=script&lang=ts&"
import style0 from "./Form.vue?vue&type=style&index=0&id=57affc4e&scoped=true&lang=css&"
import style1 from "./Form.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57affc4e",
  null
  
)

export default component.exports